import React, {FC, useState} from 'react';
import GatewayService from "../service/GatewayService";
import {Feed} from "../models/Feed";
// @ts-ignore
// import faker from 'faker';


const FeedRowComponent : FC<Feed> = (feed: Feed) => {
    return <tr>
        <td>{feed.time}</td>
        <td>{feed.tradingsymbol}</td>
        <td>{feed.buyers[0].price}({feed.buyers[0].quantity}-{feed.buyers[0].orders})</td>
        <td>{feed.buyers[1].price}({feed.buyers[1].quantity}-{feed.buyers[1].orders})</td>
        <td>{feed.sellers[0].price}({feed.sellers[0].quantity}-{feed.sellers[0].orders})</td>
        <td>{feed.lastTrade}</td>
        <td>{feed.ltt}</td>
        <td>{feed.ltq}</td>
        <td>{feed.volume}</td>
        <td>{feed.source}</td>
    </tr>
}

const FeedComponent:FC = () => {
    const [symbol, setSymbol] = useState("")
    const [sellPrice, setSellPrice] = useState("5850.0")
    const strArr: Feed[] = [];
    const [data, setData] = useState(strArr)
    const [days, setDays] = useState(0)
    const [refresh, setRefresh] = useState(false)
    function feed() {
        GatewayService.feed(symbol, days).then(it=>{
            setData(it)
        })
    }
    function feedBySellPrice() {
        GatewayService.feedBySellPrice(sellPrice).then(it=>{
            setData(it)
        })
    }
    function filterSource(source:string){
        setData(data.filter(d => d.source===source))
    }

    function sortBySellPrice() {
        setData(data.sort((a,b)=>a.sellers[0].price-b.sellers[0].price))
        setRefresh(!refresh)
    }

    return<>
        symbol:<input type="text" value={symbol} onChange={event => setSymbol(event.target.value)}/>
        days:<input type="text" value={days} onChange={event => setDays(parseInt(event.target.value))}/>
        <button onClick={()=>feed()}>get feed</button>
        <button onClick={()=>feedBySellPrice()}>get feed by sell price less than</button>
        <input type="number" value={sellPrice} onChange={event => setSellPrice(event.target.value)}/>

        <button onClick={()=>filterSource("angel")}>only angel</button>
        <button onClick={()=>filterSource("zerodha")}>only zerodha</button>
        <table className={"full"}>
            <thead>
            <tr>
                <th>time</th>
                <th>symbol</th>
                <th>buyer1</th>
                <th>buyer2</th>
                <th onClick={()=>sortBySellPrice()}>seller</th>
                <th>last trade</th>
                <th>ltt</th>
                <th>ltq</th>
                <th>volume</th>
                <th>sorce</th>
            </tr>
            </thead>
            <tbody>
            {data.map(feed => <FeedRowComponent
                // key = {feed.sgb.tradingsymbol}
                {...feed}/>)}
            </tbody>
        </table>    </>
}

export default FeedComponent